import React from 'react'
// import AboutImage1 from '../assets/more-info.jpg'
import temp_1 from '../assets/temp_1.jpg'
import temp_2 from '../assets/temp_2.jpg'
// import AboutImage2 from '../assets/customization.jpg';
import quote_bg from '../assets/quote_bg.jpg';
import Footer from './Footer';
import FooterVideo from './FooterVideo';

const About = () => {
  return (
    <div id='about'>
      <div className='w-full max-w-6xl mx-auto px-6 py-16 md:py-24'>
        {/* Introduction Section */}
        <div className='text-center mb-16'>
          <h1 className='text-4xl md:text-5xl font-bold text-gray-800 mb-6'>
            We are <span className='text-blue-600'>Jyotinay Analytics</span>
          </h1>
          <div className='w-24 h-1 bg-blue-500 mx-auto mb-8'></div>
          <div className='max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed space-y-6'>
            <p>
              Jyotinay Analytics is a trusted data consultancy focused on delivering long-term business value. We prioritize integrity, transparency, and results-driven strategies.
            </p>
            <p>
              Instead of offering off-the-shelf tools, we start by immersing ourselves in your business goals. Our strategies are tailored to create sustainable improvements aligned with your vision.
            </p>
            <p>
              Many organizations underestimate how deeply data impacts every decision. We help clients uncover those opportunities, align teams, and build a culture where data drives progress.
            </p>
          </div>
        </div>

        {/* What We Do Section */}
        <div className='mb-16'>

          <div className='flex flex-col md:flex-row items-center gap-8'>
            <div className='md:w-1/2'>
              <img
                src={temp_1}
                alt="Our team working"
                className='rounded-lg shadow-lg w-full h-auto object-cover'
              />
            </div>
            <div className='md:w-1/2 text-lg text-gray-600 leading-relaxed space-y-6'>
              <h2 className='text-3xl font-bold text-gray-800 mb-8 text-center'>What We Do</h2>
              <p>
                We partner with clients to create a strong data foundation, ensuring every department communicates effectively using insights. Our goal is to transform how decisions are made — with clarity, speed, and confidence.
              </p>
              <p>
                From data culture to performance tracking, we enable you to manage operations with a clearer, unified view of your business landscape.
              </p>
            </div>
          </div>
        </div>

        {/* Services Section */}
        <div className='mb-16'>
          <div className='flex flex-col md:flex-row-reverse items-center gap-8'>
            <div className='md:w-1/2'>
              <img
                src={temp_2}
                alt="Data analytics services"
                className='rounded-lg shadow-lg w-full h-auto object-cover'
              />
            </div>
            <div className='md:w-1/2 text-lg text-gray-600 leading-relaxed space-y-6'>
              <p>
                Our focus is on empowering your team to lead with data. We integrate analytics into your workflows, ensuring adoption and impact across your organization.
              </p>
              <p>
                Our solutions include Data Strategy, BI Reporting, Modern Data Architecture, Advanced Analytics, AI-Driven Automation, Dashboards, Workforce Training, and more.
              </p>
            </div>
          </div>
        </div>

        {/* Importance Section */}
        <div className='text-center'>
          <h2 className='text-3xl font-bold text-gray-800 mb-8'>Why This Matters for Your Business</h2>
          <div className='max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed'>
            <p>
              As global data generation surges, businesses that embrace smart analytics will lead their industries. Being data-savvy is no longer optional — it's essential for growth, efficiency, and innovation.
            </p>
          </div>
        </div>

        {/* Quote Section */}
        <div className='mt-20 relative'>
          <div className='relative'>
            {/* Background Image with Reduced Opacity */}
            <img
              className='w-full h-60 object-cover'
              src={quote_bg}
              alt='quote background'
              style={{ opacity: 0.85 }}
            />

            {/* Text Overlay */}
            <div className='absolute inset-0 flex items-center justify-center'>
              <p className='text-white text-2xl md:text-3xl font-bold text-center px-8 max-w-4xl'>
                “Organizations that invest in data literacy and culture today are laying the foundation for tomorrow’s most adaptive and successful enterprises.”
              </p>
            </div>
          </div>
        </div>


      </div>
      <FooterVideo />
      <Footer />
    </div>
  )
}

export default About